import { useState } from 'react';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import { config } from 'Constants';

import { useFormik } from 'formik';
import * as yup from 'yup';
import Grid from '@mui/material/Grid';
// import CardBody from 'components/Card/CardBody.js';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

// import Chip from '@mui/material/Divider';
import { postDiger, updateDiger } from 'services/api/form';
import { getTags } from 'services/api/general/tag';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import AaroLoadingScreen from 'components/Loading';
import Typography from '@mui/material/Typography';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { Box } from '@mui/material';
import OutlinedFormTextField from '../FormComponents/OutlinedFormTextField';

const validationSchema = yup.object({
    baslik: yup
        .string('Başlık giriniz')
        .min(5, '5 karakterden fazla olmalıdır')
        .max(200, '200 karakterden az olmalıdır')
        .required('Lütfen geçerli bir başlık giriniz'),
});

const styles = {
    title: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: '1.125rem',
        color: '#999999',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    gridStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    gridStyleBooleans: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    containerMargin: {
        marginLeft: '3%',
        marginRight: '3%',
    },
    dashedSeperator: {
        borderTop: '2px dashed #999999',
        marginLeft: '3%',
        marginRight: '3%',
    },
    dottedSeperator: {
        borderTop: '1px dotted #8c8b8b',
        marginLeft: '3%',
        marginRight: '3%',
    },
    emptySpace: {
        marginBottom: '16px',
    },
    formControl: (theme) => ({
        margin: theme.spacing(1),
        width: '100%',
        minWidth: 120,
    }),
};

const fetchTags = async (id) => {
    const response = await getTags(id).then((rp) => (rp.data?.result?.tags ? rp.data?.result?.tags : []));
    return response;
};
const TAG_GROUP_ID_DEMAND = config.fixedID.DEMAND_STATUS_TAG_GROUP_ID;
export const Diger = (props) => {
    const queryClient = useQueryClient();
    const {
        data: tags,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['fetchTagGroups', TAG_GROUP_ID_DEMAND],
        queryFn: () => fetchTags(TAG_GROUP_ID_DEMAND),
        staleTime: 600000,
    });

    const user = JSON.parse(localStorage.getItem('user'));
    const [disableOnSubmit, setDisableOnSubmit] = useState(false);
    const { demandID, initial, id, projectID, setOpen } = props;

    const formik = useFormik({
        initialValues: {
            baslik: initial?.baslik || 'Diger',
            gorsel: initial?.gorsel || '',
            ekNot: initial?.ekNot || '',
            miktar: initial?.miktar || 0,
            yoneticiNotu: initial?.yoneticiNotu || '',
            verilenFiyat: initial?.verilenFiyat || null,
            durumu: initial?.durumu || '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setDisableOnSubmit(true);
            if (id) {
                updateDiger(id, values)
                    .then(() => {
                        queryClient.invalidateQueries({ queryKey: ['fetchDemand', demandID] });
                        setOpen(false);
                    })
                    .catch((err) => console.log(err));
            } else {
                postDiger(demandID, values)
                    .then(() => {
                        queryClient.invalidateQueries({ queryKey: ['fetchDemand', demandID] });
                        setOpen(false);
                    })

                    .catch((err) => console.log(err));
            }
        },
    });
    if (isLoading) return <AaroLoadingScreen />;

    if (error) return 'Bir Hata Oluştu: ' + error.message;
    return (
        <div>
            <Grid container>
                <Grid size={12}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container justify="flex-start">
                            {/* Başlık */}
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    id="baslik"
                                    name="baslik"
                                    label="Başlık"
                                    placeholder="Örn: 18lik U Diger"
                                    value={formik.values.baslik}
                                    onChange={formik.handleChange}
                                    error={formik.touched.baslik && Boolean(formik.errors.baslik)}
                                    helperText={formik.touched.baslik && formik.errors.baslik}
                                />
                            </Grid>
                            {/* Ek Not*/}
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    id="ekNot"
                                    name="ekNot"
                                    label="Eklemek İstedikleriniz"
                                    multiline
                                    variant="outlined"
                                    rows={3}
                                    value={formik.values.ekNot}
                                    onChange={formik.handleChange}
                                    error={formik.touched.ekNot && Boolean(formik.errors.ekNot)}
                                    helperText={formik.touched.ekNot && formik.errors.ekNot}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                }}
                            >
                                <OutlinedFormTextField
                                    itemID="miktar"
                                    label="Miktar (Adet)"
                                    placeHolder="Örn: 1000"
                                    type="number"
                                    formik={formik}
                                    step="1"
                                    adornment="AD"
                                />
                            </Grid>
                            {/* Ayraç Boşluklu */}
                            <Grid container>
                                <Grid x={12} sx={styles.emptySpace}>
                                    {' '}
                                </Grid>
                                <Grid sx={styles.dashedSeperator} size={12}>
                                    {' '}
                                </Grid>
                                <Grid x={12} sx={styles.emptySpace}>
                                    {' '}
                                </Grid>
                            </Grid>
                            {/* Yönetici Alanı*/}
                            <Grid container sx={styles.containerMargin}>
                                {/* Yönetici Notu*/}
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4,
                                    }}
                                >
                                    <TextField
                                        disabled={user.role != 'superadmin'}
                                        fullWidth
                                        id="yoneticiNotu"
                                        name="yoneticiNotu"
                                        label="Yönetici Notu"
                                        value={formik.values.yoneticiNotu}
                                        onChange={formik.handleChange}
                                        error={formik.touched.yoneticiNotu && Boolean(formik.errors.yoneticiNotu)}
                                        helperText={formik.touched.yoneticiNotu && formik.errors.yoneticiNotu}
                                    />
                                </Grid>
                                {/* Verilen Fiyat */}
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4,
                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        id="verilenFiyat"
                                        name="verilenFiyat"
                                        label="Birim Fiyat"
                                        type="number"
                                        value={formik.values.verilenFiyat}
                                        onChange={formik.handleChange}
                                        error={formik.touched.verilenFiyat && Boolean(formik.errors.verilenFiyat)}
                                        // disabled={user.role != 'superadmin'}
                                        helperText={formik.touched.verilenFiyat && formik.errors.verilenFiyat}
                                        slotProps={{
                                            htmlInput: { step: '0.01' },
                                        }}
                                    />
                                </Grid>

                                {/* Teklif Durumu */}
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            pl: 1,
                                            width: '100%',
                                            minWidth: 120,
                                            height: '100%',
                                        }}
                                    >
                                        <FormControl
                                            sx={(theme) => ({
                                                width: '100%',
                                                minWidth: 120,
                                                height: '100%',
                                                margin: theme.spacing(1),
                                            })}
                                        >
                                            <InputLabel id="durumu">
                                                {formik?.values?.durumu?.name
                                                    ? formik.values.durumu.name
                                                    : 'Talep Durumu'}
                                            </InputLabel>
                                            <Select
                                                id="durumu"
                                                name="durumu"
                                                value={formik.values.durumu}
                                                onChange={formik.handleChange}
                                                variant="outlined"
                                                defaultValue="Talep Durumu"
                                                sx={{
                                                    width: '100%',
                                                    minWidth: 120,
                                                    height: '100%',
                                                }}
                                                required
                                            >
                                                {tags.map((tag) => (
                                                    <MenuItem value={tag}>{tag.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>
                            {/* Ayraç Boşluklu */}
                            <Grid container>
                                <Grid x={12} sx={styles.emptySpace}>
                                    {' '}
                                </Grid>
                                <Grid sx={styles.dashedSeperator} size={12}>
                                    {' '}
                                </Grid>
                                <Grid x={12} sx={styles.emptySpace}>
                                    {' '}
                                </Grid>
                            </Grid>
                            {/* Kaydet Butonu */}
                            <Button variant="contained" fullWidth type="submit" disabled={disableOnSubmit}>
                                <Typography variant="h6" sx={{ color: '#fff' }}>
                                    Kaydet
                                </Typography>
                                ;
                            </Button>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </div>
    );
};
